import { render, staticRenderFns } from "./SelectProductPlainItem.vue?vue&type=template&id=18907036&scoped=true&"
import script from "./SelectProductPlainItem.vue?vue&type=script&lang=js&"
export * from "./SelectProductPlainItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductPlainItem.vue?vue&type=style&index=0&id=18907036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18907036",
  null
  
)

export default component.exports